import web3NoAccount from "./web3";
import NftPurchase from "./SmartCityABI.json";
import ValidatorAbi from "./ValidatorABI.json";

const getContract = (abi, address, web3) => {
  const _web3 = web3;
  // console.log('_web3',_web3);
  return new _web3.eth.Contract(abi, address);
};

export const fetchNftBalance = (address, web3) => {
  return getContract(NftPurchase, address, web3);
};
export const ValidatorContract = (address, web3) => {
  return getContract(ValidatorAbi, address, web3);
};
